export const STEM_NAMES = ["vocals", "drums", "bass", "other"];

export function stemsAreReady(task) {
  return task?.status === "completed" &&
    !["stale", "failed"].includes(task.processing_status) &&
    STEM_NAMES.every(name => Boolean(task.stems?.[name]));
}

export function stemTaskIsTerminal(task) {
  return stemsAreReady(task) || task?.status === "failed" ||
    ["failed", "not_required", "stale"].includes(task?.processing_status);
}

export function stemStatusLabel(task) {
  if (stemsAreReady(task)) return "Pistas listas";
  if (task?.status === "failed" || task?.processing_status === "failed") return "No se pudieron separar las pistas";
  if (task?.processing_status === "not_required") return "Separacion no disponible";
  if (task?.processing_status === "stale") return "Las pistas necesitan actualizarse";
  if (task?.processing_status === "waiting_for_existing_job") return "Esperando procesamiento existente";
  if (task?.processing_status === "queued" || task?.status === "pending") return "Pistas en cola";
  const stages = { preparing: "Preparando audio", downloading: "Preparando audio", processing: "Separando instrumentos", queued: "Pistas en cola", separating: "Separando instrumentos", validating: "Validando pistas", saving: "Guardando pistas", uploading: "Guardando pistas" };
  return stages[task?.stage] || task?.stage || "Separando pistas...";
}

export const stemPollDelay = attempt => Math.min(15000, 2000 * (1.5 ** Math.min(attempt, 6)));
